import uPlot from "uplot";
import { throttle } from "../../utils/throttle";

export function resize(element) {
  let resizeObserver = null;
  let lastWidth = 0;
  let lastHeight = 0;

  function getSize() {
    return {
      width: element.offsetWidth,
      height: element.offsetHeight,
    };
  }

  const throttledOnResize = throttle((uplot) => {
    const { width, height } = getSize();
    if (width === lastWidth && height === lastHeight) return;
    lastWidth = width;
    lastHeight = height;
    uplot.setSize({ width, height });
  }, 50);

  function init(uplot) {
    // Seed last{Width,Height} so the ResizeObserver's initial fire (which
    // delivers the current dimensions) doesn't trigger a redundant redraw.
    const { width, height } = getSize();
    lastWidth = width;
    lastHeight = height;

    resizeObserver = new ResizeObserver(() => throttledOnResize(uplot));
    resizeObserver.observe(element);
  }

  function destroy() {
    resizeObserver?.disconnect();
    resizeObserver = null;
  }

  return {
    opts: (_u, opts) => {
      uPlot.assign(opts, getSize());
    },
    hooks: {
      init,
      destroy,
    },
  };
}
